import {
    Card,
    DatePicker,
    FilterButton,
    Popover,
    PopoverContent,
    PopoverTrigger,
    SearchInput,
} from "@jhool-io/fe-components";
import { format } from "date-fns";
import { useSearchParams } from "react-router-dom";
import { convertDateFilterStringToDate } from "../../../../../utils/helpers";
import MyPendingTasks from "./MyPendingTasks/MyPendingTasks";

export default function ProvidersPendingTasks() {
    const [searchParams, setSearchParams] = useSearchParams();

    const fromDateFilter = searchParams.get("task_from_date");
    const toDateFilter = searchParams.get("task_to_date");
    const clientName = searchParams.get("task_client") || "";

    const fromDateFilterToDate = convertDateFilterStringToDate(fromDateFilter);
    const toDateFilterToDate = convertDateFilterStringToDate(toDateFilter);

    const handleClientNameFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value === "") searchParams.delete("task_client");
        else searchParams.set("task_client", e.target.value);
        searchParams.set("page", "1");
        setSearchParams(searchParams);
    };

    const handleFromDateFilterChange = (date: Date | null) => {
        if (date === null) searchParams.delete("task_from_date");
        else searchParams.set("task_from_date", format(date, "yyyy-MM-dd"));
        searchParams.set("page", "1");
        setSearchParams(searchParams);
    };

    const handleToDateFilterChange = (date: Date | null) => {
        if (date === null) searchParams.delete("task_to_date");
        else searchParams.set("task_to_date", format(date, "yyyy-MM-dd"));
        searchParams.set("page", "1");
        setSearchParams(searchParams);
    };

    return (
        <Card classNames="flex flex-col relative overflow-y-auto h-[600px] lg:h-[430px]">
            <div className="sticky top-0 left-0 z-[5]">
                <div className="flex justify-between items-center flex-wrap gap-[--spacing-items] pb-[--padding-card-y-lg] [border-bottom:1px_solid_var(--color-stroke)]">
                    <h3 className="text-base font-medium tracking-[-0.176px]">
                        Pending Tasks
                    </h3>
                    <div className="flex gap-[--spacing-items] items-center flex-wrap">
                        <SearchInput
                            placeholder="Search by client name"
                            onChange={handleClientNameFilter}
                            defaultValue={clientName}
                            containerClass="md:w-[250px]"
                        />
                        <Popover>
                            <PopoverTrigger asChild>
                                <FilterButton>Date</FilterButton>
                            </PopoverTrigger>
                            <PopoverContent align="end">
                                <div className="mb-2">
                                    <DatePicker
                                        label="From"
                                        placeholderText="MM/DD/YYYY"
                                        selected={fromDateFilterToDate}
                                        onChange={handleFromDateFilterChange}
                                        maxDate={
                                            toDateFilterToDate ||
                                            new Date(Date.now())
                                        }
                                        isClearable
                                    />
                                </div>
                                <DatePicker
                                    label="To"
                                    placeholderText="MM/DD/YYYY"
                                    selected={toDateFilterToDate}
                                    onChange={handleToDateFilterChange}
                                    minDate={fromDateFilterToDate}
                                    isClearable
                                />
                            </PopoverContent>
                        </Popover>
                    </div>
                </div>
            </div>
            <div className="flex-1 py-[--spacing-items] overflow-y-auto">
                <MyPendingTasks />
            </div>
        </Card>
    );
}
